import { SkiUserManager } from "@ski/oidc";
import Vuex from "vuex";
export async function createAuthStore(options) {
    const manager = new SkiUserManager({
        ...options,
        storage: window.localStorage,
    });
    const user = await manager.initialize();
    const store = new Vuex.Store({
        state() {
            return {
                profile: user,
            };
        },
        getters: {
            /**
             * Convenience method to check if the user is logged in or not.
             * @param state
             * @returns true if the user is logged in, false otherwise
             */
            isLoggedIn(state) {
                return !!state.profile;
            },
            /**
             * Convenience method to get the users roles.
             * @param state
             * @returns an array of roles
             */
            roles(state) {
                if (state.profile && state.profile.roles)
                    return state.profile.roles;
                return [];
            },
        },
        mutations: {
            /**
             * For internal use only to set the profile in the store.
             * @param state
             * @param profile
             */
            setProfile(state, profile) {
                state.profile = profile;
            },
        },
        actions: {
            /**
             * This method will initiate the login flow and redirect the user to the SSO login page
             * @param returnUrl this value will be passed on throughout the login flow, so that you can redirect to this page after a succesful login.
             * @returns Promise
             */
            async signIn(_, returnUrl) {
                await manager.signIn(returnUrl);
            },
            /**
             * Completes the signin flow, by saving the user details in the specified storage.
             * @returns Promise
             */
            async completeSignin() {
                return manager.completeSignin();
            },
            /**
             * This method will initiate the logout flow and redirect the user to the SSO login page
             * @returns Promise
             */
            async signOut(_, returnUrl) {
                await manager.signOut(returnUrl);
            },
            /**
             * Completes the signout flow by removing the user details from the specified storage.
             * @returns
             */
            completeSignOut() {
                return manager.completeSignout();
            },
            /**
             * This is a convenience method to figure out if you should allow access to a page or either do a no-access or login redirect.
             * Using this method, requires you to set the meta.protected property on the route to mark which routes are behind login.
             * @param routeMetadata of the route which is being redirected to
             * @param defaultValues default values for the route meta properties. This is useful if you need the same value for most routes, and only want to override a few.
             * @returns wether you should
             */
            getPageRedirectAction(_, { meta, defaultValues, }) {
                return manager.getPageRedirectAction(meta, defaultValues);
            },
        },
    });
    manager.setUserChangeListener((profile, token) => {
        store.commit("setProfile", profile);
        options.onAccessTokenChange(token);
    });
    return store;
}
